import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling"); // polling | paid | failed | timeout

  useEffect(() => {
    if (!sessionId) {
      setStatus("failed");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
        if (data.status === "failed" || data.status === "expired") {
          setStatus("failed");
          return;
        }
      } catch {
        // keep polling
      }
      if (attempts >= 10) {
        setStatus("timeout");
        return;
      }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#151613] text-[#f1e0c5] flex items-center justify-center px-6" data-testid="payment-success-page">
      <div className="max-w-sm text-center space-y-4">
        {status === "polling" && (
          <>
            <Loader2 className="w-10 h-10 mx-auto animate-spin text-[#D4AF37]" />
            <p className="text-sm text-[#f1e0c5]/60">Confirming your payment…</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-14 h-14 mx-auto text-[#4d7c0f]" />
            <h1 className="font-display text-3xl">You're in!</h1>
            <p className="text-sm text-[#f1e0c5]/60">Your GM access is active. Time to build a table.</p>
            <Button data-testid="payment-success-dashboard-button" onClick={() => navigate("/dashboard")} className="rounded-full bg-[#D90429] hover:bg-[#b8031f] mt-2">Go to Dashboard</Button>
          </>
        )}
        {(status === "failed" || status === "timeout") && (
          <>
            <XCircle className="w-14 h-14 mx-auto text-[#D90429]" />
            <h1 className="font-display text-3xl">Something went wrong</h1>
            <p className="text-sm text-[#f1e0c5]/60">We couldn't confirm this payment. If you were charged, check back shortly or contact support.</p>
            <Link to="/dashboard" data-testid="payment-failed-dashboard-link" className="inline-block mt-2 text-[#D4AF37] underline text-sm">Back to Dashboard</Link>
          </>
        )}
      </div>
    </div>
  );
}
